import React, { Fragment, useState, useEffect } from "react";
import { backend, API_URL } from "../../../config";
import {
  Button,
  Typography,
  Modal,
  CircularProgress,
  Container,
  Grid,
  TextField,
  InputLabel,
  Autocomplete,
} from "@mui/material";

import WarningIcon from "@mui/icons-material/Warning";

import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

import ManagementNav from "../../../features/OrderManagement/components/Nav/ManagementNav";
import { downloadInvoices } from "../ExportInvoices/ExportInvoices";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600)]: {
      width: 900,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(5),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const GenerateInvoices = (props) => {
  const classes = useStyles();

  const cDate = new Date();

  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState(cDate);
  const [orders, setOrders] = useState([]);
  const [ordersSelected, setOrdersSelected] = useState([]);
  const [ordersExcluded, setOrdersExcluded] = useState([]);
  const [ordersInvoiced, setOrdersInvoiced] = useState([]);
  const [downloadInProgress, setDownloadInProgress] = useState(false);

  const handleChangeOrders = (e, value) => {
    setOrdersSelected(value);
  };

  const handleChangeDate = (e) => {
    const { value } = e.target;
    setOrders([]);
    setOrdersSelected([]);
    setDeliveryDate(value);
  };

  const handleDownloadInvoices = async () => {
    setDownloadInProgress(true);

    const downloadResponse = await downloadInvoices(
      ordersSelected,
      deliveryDate,
    )
      .then((result) => {
        setDownloadInProgress(false);
      })
      .catch((error) => {
        // todo: work on a function to process all the error possibilities and return the expected error structure
        setErrorInfo((prevState) => ({
          error: true,
          message: "" + error,
        }));
      });

    console.log(downloadResponse);
  };

  const warningFormat = () => {
    const notPickedOrders = ordersSelected.filter(
      (item) => !item.picking_complete,
    );

    return notPickedOrders.length ? (
      <>
        <div style={{ color: "red" }}>
          <b>The following orders have not completed picking yet:</b>
          {` ${ordersExcluded.join(", ")}`}
        </div>
        <br />
        <br />
      </>
    ) : (
      <></>
    );
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to bulk generate invoices?
          <br />
          <br />
          {warningFormat()}
          <div align="right">
            <Button
              onClick={() => toggleConfirmModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Generating Invoices <br />
              This may take some time relative to the number of invoices
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while generating invoices
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "scroll",
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <b>Error:</b>
                <br />
                <div dangerouslySetInnerHTML={{ __html: errorInfo.message }} />
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveRequest()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The invoices were generated successfully.
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while generating invoices
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "scroll",
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <b>Error:</b>
                <br />
                <div dangerouslySetInnerHTML={{ __html: errorInfo.message }} />
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveRequest()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDownloadInvoices()}
              className={classes.button}
              style={{ marginRight: 5 }}
              disabled={downloadInProgress}
            >
              Download
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              disabled={downloadInProgress}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const resolveRequest = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    toggleConfirmModal();
    setErrorInfo({ error: false, message: "" });
  };

  const sendRequest = async () => {
    setLoadingFlag(true);

    Promise.all(
      ordersSelected.map(
        async (orderObj) =>
          await backend
            .post(`${API_URL}orders/${orderObj.id}/generateinvoice`)
            .then(({ data }) => data)
            .catch((error) => {
              console.log(error);
              const errorData = error.response.data;

              setErrorInfo((prevState) => {
                let newMsg =
                  typeof errorData === "object"
                    ? errorData.hasOwnProperty("message")
                      ? errorData.message
                      : errorData.detail
                    : error.message;

                if (newMsg === undefined) {
                  const orderId = orderObj.id;

                  if (!prevState.message.includes(orderId)) {
                    newMsg = `Invoice ${orderId}: ${error.response.statusText}`;
                  } else {
                    newMsg = "";
                  }
                }

                if (newMsg !== "") {
                  const errorMsg =
                    prevState.message +
                    `${prevState.message === "" ? "" : "<br />"}` +
                    newMsg;

                  return {
                    error: true,
                    message: errorMsg,
                  };
                }

                return prevState;
              });
            }),
      ),
    ).then(async (result) => {
      console.log(result);

      setLoadingFlag(false);
      setFinishedFlag(true);
    });
  };

  useEffect(() => {
    const getOrders = async () => {
      let deliveryDateObj = new Date(deliveryDate);

      const deliveryDateParam = new Date(
        deliveryDateObj.getTime() - deliveryDateObj.getTimezoneOffset() * 60000,
      )
        .toISOString()
        .split("T")[0];

      await backend
        .get(
          `${API_URL}orders?no_page=1&start_date=${deliveryDateParam}&end_date=${deliveryDateParam}`,
        )
        .then(({ data }) => {
          if (data.length) {
            let oSelected = [];
            let oExcluded = [];
            let oInvoiced = [];

            data.forEach((item) => {
              if (item.invoiced) {
                oInvoiced.push(
                  `${item.customer ? item.customer.username : "Anonymous"} #${
                    item.id
                  }`,
                );
              } else if (!item.invoiced && item.picking_complete) {
                oSelected.push(item);
              } else {
                oExcluded.push(
                  `${item.customer ? item.customer.username : "Anonymous"} #${
                    item.id
                  }`,
                );
              }
            });

            setOrders(data);
            setOrdersInvoiced(oInvoiced);
            setOrdersExcluded(oExcluded);
            setOrdersSelected(oSelected);
          }
        });
    };

    if (deliveryDate !== null) {
      getOrders();
    }
  }, [deliveryDate]);

  return (
    <Container style={{ minHeight: "80vh" }}>
      <Modal open={confirmModal} onClose={toggleConfirmModal}>
        {confirmModalContent}
      </Modal>
      <ManagementNav {...props} />
      <Typography component="h6" variant="h6" align="center">
        Bulk Generate Invoices
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}></Grid>
        <Grid item xs={12} sm={12}>
          Select the orders you would like to generate invoice for, not picked
          complete orders are not pre-selected
        </Grid>
        <Grid item xs={12} sm={12}></Grid>
        <Grid item xs={12} sm={12}>
          Load orders from a given date.
        </Grid>
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              value={deliveryDate}
              renderInput={(props) => (
                <TextField
                  {...props}
                  fullWidth
                  label="Delivery date"
                  variant="standard"
                />
              )}
              onChange={(date) =>
                handleChangeDate({
                  target: {
                    name: "delivery_date",
                    value: date,
                  },
                })
              }
            />
          </LocalizationProvider>
        </Grid>
        {deliveryDate !== null ? (
          <>
            <Grid item xs={12} sm={12}>
              <InputLabel shrink id="orders">
                Orders
              </InputLabel>
              <Autocomplete
                fullWidth
                multiple
                disablePortal
                size="small"
                name="orders"
                options={orders}
                getOptionLabel={(option) =>
                  `${
                    option.customer ? option.customer.username : "Anonymous"
                  } #${option.id}`
                }
                renderInput={(params) => (
                  <TextField {...params} size="small" variant="standard" />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    {`${
                      option.customer ? option.customer.username : "Anonymous"
                    } #${option.id}`}
                    {!option.picking_complete && (
                      <WarningIcon
                        color="warning"
                        label="Not picked complete"
                      />
                    )}
                  </li>
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(e, value) => handleChangeOrders(e, value)}
                helpertext="Select the orders to include in the receipt difference."
                value={ordersSelected}
              />
            </Grid>
            {ordersExcluded.length > 0 && (
              <Grid item xs={12}>
                <b>The following orders have not completed picking yet:</b>
                {` ${ordersExcluded.join(", ")}`}
              </Grid>
            )}
            {ordersInvoiced.length > 0 && (
              <Grid item xs={12}>
                <b>
                  There are {ordersInvoiced.length} orders invoiced already:
                </b>
                {` ${ordersInvoiced.join(", ")}`}
              </Grid>
            )}
          </>
        ) : (
          <></>
        )}
        <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => toggleConfirmModal()}
            className={classes.button}
            disabled={!ordersSelected.length || loadingFlag}
          >
            Generate Invoices
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default GenerateInvoices;
